export class Logger {
  private name: string;
  private nameColor: string = '';
  private debug: boolean = false;

  constructor(name: string, debug?: boolean) {
    this.name = `[${name}]`;
    if (debug !== undefined) {
      this.init(debug);
    }
  }

  private generateNameColor(name: string): string {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      const char = name.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }

    const hue = Math.abs(hash) % 360;
    const saturation = 60 + (Math.abs(hash) % 40);
    const lightness = 45 + (Math.abs(hash) % 20);

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  }

  init(debug: boolean) {
    this.debug = debug;

    if (this.nameColor) return;
    if (this.debug) {
      this.nameColor = this.generateNameColor(this.name);
    }
  }

  log(key: string, ...args: any[]) {
    if (!this.debug) return;
    console.log(
      `%c${this.name} %c${key}:`,
      `color: ${this.nameColor}; font-weight: normal;`,
      'color: #2196F3; font-weight: bold;',
      ...args
    );
  }

  asyncLog(key: string, ...args: any[]) {
    if (!this.debug) return () => {};
    const resultFlag = {};
    let result: any = resultFlag;
    const startTime: number = performance.now();
    let diffTime: number = 0;
    let time: string = '';

    const resultTrigger = {
      get result(): any {
        return result === resultFlag ? resultTrigger : result;
      },
      get time(): any {
        return result === resultFlag
          ? resultTrigger
          : `End by ${time} [${diffTime.toFixed(2)}ms]`;
      },
    };

    this.log(key, ...args);

    console.log(
      `%c${this.name} ${key}:%c└──`,
      'color: transparent;',
      `font-weight: normal;`,
      resultTrigger
    );

    return (res: any) => {
      result = res;
      const date = new Date();
      time = `${date.toLocaleString()}:${date.getMilliseconds()}`;
      diffTime = performance.now() - startTime;
    };
  }

  error(key: string, ...args: any[]) {
    if (!this.debug) return;
    console.error(
      `${this.name} %c${key}:`,
      `color: ${this.nameColor}; font-weight: normal;`,
      'color: #F44336; font-weight: bold;',
      ...args
    );
  }
  [Symbol.dispose](): void {
    this.debug = false;
  }
}
